import React, { useState } from "react";
import { X } from "lucide-react";
import "./Categories.css";

export default function CategoryModal({
  isOpen,
  onClose,
  onSave,
  title,
  categoryData,
  setCategoryData,
  error,
}) {
  const [isSaving, setIsSaving] = useState(false);

  if (!isOpen) return null;

  const handleSaveClick = async () => {
    if (isSaving) return; // prevent double click

    try {
      setIsSaving(true);
      await onSave(); // wait for parent API call
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-card">

        <h2>{title}</h2>

        <button
          className="modal-close-kanchi"
          onClick={onClose}
          disabled={isSaving}
        >
          <X size={18} />
        </button>

        <label>Category Name</label>
        <input
          type="text"
          placeholder="e.g. Beverages, Snacks"
          value={categoryData.name}
          disabled={isSaving}
          onChange={(e) =>
            setCategoryData({
              ...categoryData,
              name: e.target.value,
            })
          }
        />

        <label>Description</label>
        <textarea
          placeholder="Brief description of this category"
          value={categoryData.description}
          disabled={isSaving}
          onChange={(e) =>
            setCategoryData({
              ...categoryData,
              description: e.target.value,
            })
          }
        />

        {error && (
          <div className="error-text">
            {error}
          </div>
        )}

        <button
          className="save-btn"
          onClick={handleSaveClick}
          disabled={isSaving}
        >
          {isSaving ? "Saving..." : title}
        </button>
      </div>
    </div>
  );
}